import { useQuery } from '@hooks/reactQuery';

import { organisationProjects } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getProjectsList } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';

import { IItemsResponse } from '@interfaces/common/response';
import { IProjectDTO } from '@interfaces/portal/dto/projectManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PROJECTS_LIST } from '@constants/queryKeys';

interface IUseQueryOrganisationProjectsReturned {
	isLoadingProjects: boolean;
	countOfRecords: number;
	projectsList: Array<IProjectDTO>;
}

export const useQueryPlatformOwnerProjects = (organizationId?: string): IUseQueryOrganisationProjectsReturned => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		status,
	} = useAppSelector(organisationProjects);

	const {
		data: projectsList,
		isLoading,
		isFetching,
	} = useQuery<IItemsResponse<IProjectDTO>>({
			queryKey: [
				GET_PROJECTS_LIST,
				{
					page,
					pageSize,
					searchValue,
					sortFieldName,
					sortDirection,
					status,
					organizationId,
				},
			],
			queryFn: extractQueryParams(getProjectsList),
			enabled: [organizationId],
			...refetchOptions,
		},
	);

	return {
		isLoadingProjects: isLoading || isFetching,
		projectsList: projectsList?.items || [],
		countOfRecords: projectsList?.count || 0,
	};
};
